import "core-js/modules/es6.string.link.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import consola from 'consola';
import { uuid } from 'vue-uuid';
import autologinMutation from '@/graphql/user/authentication/autologin.gql';
import logoutUserMutation from '@/graphql/user/authentication/logoutUser.gql';
import signUpCustomerMutation from '@/graphql/user/authentication/signUpCustomer.gql';
import getAfterSalesEligibilityMutation from '@/graphql/user/getAfterSalesEligibility.gql';
import getAfterSalesLinkMutation from '@/graphql/user/getAfterSalesLink.gql';
import specialConditions from '@/graphql/user/propositions/specialConditions.gql';
import userLogin from '@/graphql/user/userLogin.gql';
import { logError } from '@/helpers/log-helper';
import addressesQuery from '~/graphql/user/address/addresses.gql';
import createUserAddressQuery from '~/graphql/user/address/createUserAddress.gql';
import deleteUserAddressQuery from '~/graphql/user/address/deleteUserAddress.gql';
import updateUserAddressMutation from '~/graphql/user/address/updateUserAddress.gql';
import addressValidationQuery from '~/graphql/user/addressValidation.gql';
import refreshTokenMutation from '~/graphql/user/authentication/refreshToken.gql';
import updateUserTokenMutation from '~/graphql/user/authentication/updateUserToken.gql';
import discountsQuery from '~/graphql/user/discounts.gql';
import generateOrderFormReceiptMutation from '~/graphql/user/generateOrderFormReceipt.gql';
import userQuery from '~/graphql/user/me.gql';
import subscribeToNewsletterMutation from '~/graphql/user/newsletter.gql';
import orderQuery from '~/graphql/user/order.gql';
import orderFormQuery from '~/graphql/user/orderForm.gql';
import orderFormsQuery from '~/graphql/user/orderForms.gql';
import ordersQuery from '~/graphql/user/orders.gql';
import profileQuery from '~/graphql/user/profile.gql';
import updateOrderFormMutation from '~/graphql/user/propositions/updateOrderForm.gql';
import updateUserInformationMutation from '~/graphql/user/updateUserInformation.gql';
import updateUserOptinMutation from '~/graphql/user/updateUserOptin.gql';
import updateUserPasswordMutation from '~/graphql/user/updateUserPassword.gql';
import { isValidToken } from '~/helpers/connection-helper';
function loginUser(_x, _x2, _x3) {
  return _loginUser.apply(this, arguments);
}
function _loginUser() {
  _loginUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apolloClient, email, password) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return apolloClient.mutate({
            errorPolicy: 'all',
            mutation: userLogin,
            variables: {
              email: email,
              password: password
            }
          });
        case 2:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _loginUser.apply(this, arguments);
}
function autologin(_x4, _x5) {
  return _autologin.apply(this, arguments);
}
function _autologin() {
  _autologin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(apolloClient, token) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return apolloClient.mutate({
            mutation: autologinMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(token)
              }
            }
          });
        case 2:
          response = _context2.sent;
          return _context2.abrupt("return", response);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _autologin.apply(this, arguments);
}
function logoutUser(_x6) {
  return _logoutUser.apply(this, arguments);
}
function _logoutUser() {
  _logoutUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: logoutUserMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            }
          });
        case 3:
          response = _context3.sent;
          return _context3.abrupt("return", response.data);
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
          logError({
            msg: "logoutUser ".concat(_context3.t0),
            context: this
          });
        case 10:
          return _context3.abrupt("return", null);
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3, this, [[0, 7]]);
  }));
  return _logoutUser.apply(this, arguments);
}
function fetchUser(_x7) {
  return _fetchUser.apply(this, arguments);
}
function _fetchUser() {
  _fetchUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context) {
    var _yield$context$app$ap, data;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!isValidToken()) {
            _context4.next = 6;
            break;
          }
          _context4.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'network-only',
            query: userQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            }
          });
        case 3:
          _yield$context$app$ap = _context4.sent;
          data = _yield$context$app$ap.data;
          return _context4.abrupt("return", data && data.user);
        case 6:
          return _context4.abrupt("return", null);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchUser.apply(this, arguments);
}
function fetchUserProfile(_x8) {
  return _fetchUserProfile.apply(this, arguments);
}
function _fetchUserProfile() {
  _fetchUserProfile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(context) {
    var _yield$context$app$ap2, data;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!isValidToken()) {
            _context5.next = 6;
            break;
          }
          _context5.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'network-only',
            query: profileQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            }
          });
        case 3:
          _yield$context$app$ap2 = _context5.sent;
          data = _yield$context$app$ap2.data;
          return _context5.abrupt("return", data && data.user);
        case 6:
          return _context5.abrupt("return", null);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _fetchUserProfile.apply(this, arguments);
}
function fetchUserOrders(_x9, _x10, _x11) {
  return _fetchUserOrders.apply(this, arguments);
}
function _fetchUserOrders() {
  _fetchUserOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(context, limit, manageOrdersErrors) {
    var _yield$context$app$ap3, data, errors;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (!isValidToken()) {
            _context6.next = 8;
            break;
          }
          _context6.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'no-cache',
            errorPolicy: manageOrdersErrors ? 'all' : 'none',
            query: ordersQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              limit: limit,
              mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
            }
          });
        case 3:
          _yield$context$app$ap3 = _context6.sent;
          data = _yield$context$app$ap3.data;
          errors = _yield$context$app$ap3.errors;
          if (manageOrdersErrors && errors) {
            consola.error(errors);
          }
          return _context6.abrupt("return", data && data.orders);
        case 8:
          return _context6.abrupt("return", null);
        case 9:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _fetchUserOrders.apply(this, arguments);
}
function fetchUserOrderForms(_x12, _x13, _x14) {
  return _fetchUserOrderForms.apply(this, arguments);
}
function _fetchUserOrderForms() {
  _fetchUserOrderForms = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(context, limit, manageOrdersErrors) {
    var _yield$context$app$ap4, data, errors;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (!isValidToken()) {
            _context7.next = 8;
            break;
          }
          _context7.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'no-cache',
            errorPolicy: manageOrdersErrors ? 'all' : 'none',
            query: orderFormsQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              limit: limit,
              mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
            }
          });
        case 3:
          _yield$context$app$ap4 = _context7.sent;
          data = _yield$context$app$ap4.data;
          errors = _yield$context$app$ap4.errors;
          if (manageOrdersErrors && errors) {
            consola.error(errors);
          }
          return _context7.abrupt("return", data && data.orderForms);
        case 8:
          return _context7.abrupt("return", null);
        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _fetchUserOrderForms.apply(this, arguments);
}
function fetchUserOrderForm(_x15, _x16) {
  return _fetchUserOrderForm.apply(this, arguments);
}
function _fetchUserOrderForm() {
  _fetchUserOrderForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(context, reference) {
    var _yield$context$app$ap5, data;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!isValidToken()) {
            _context8.next = 6;
            break;
          }
          _context8.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'no-cache',
            query: orderFormQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              reference: reference,
              mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
            }
          });
        case 3:
          _yield$context$app$ap5 = _context8.sent;
          data = _yield$context$app$ap5.data;
          return _context8.abrupt("return", data && data.orderForm);
        case 6:
          return _context8.abrupt("return", null);
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _fetchUserOrderForm.apply(this, arguments);
}
function fetchUserOrder(_x17, _x18) {
  return _fetchUserOrder.apply(this, arguments);
}
function _fetchUserOrder() {
  _fetchUserOrder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(context, reference) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (!isValidToken()) {
            _context9.next = 6;
            break;
          }
          locale = context.state.i18n.currentLocale.iso;
          _context9.next = 4;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'no-cache',
            query: orderQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              reference: reference,
              locale: locale,
              mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
            }
          });
        case 4:
          response = _context9.sent;
          return _context9.abrupt("return", response.data);
        case 6:
          return _context9.abrupt("return", null);
        case 7:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _fetchUserOrder.apply(this, arguments);
}
function fetchUserOrderReturnLink(_x19, _x20) {
  return _fetchUserOrderReturnLink.apply(this, arguments);
}
function _fetchUserOrderReturnLink() {
  _fetchUserOrderReturnLink = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(apolloClient, reference) {
    var _data$getAfterSalesLi, _yield$apolloClient$m, data;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!isValidToken()) {
            _context10.next = 6;
            break;
          }
          _context10.next = 3;
          return apolloClient.mutate({
            mutation: getAfterSalesLinkMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              input: {
                reference: reference
              }
            }
          });
        case 3:
          _yield$apolloClient$m = _context10.sent;
          data = _yield$apolloClient$m.data;
          return _context10.abrupt("return", data === null || data === void 0 ? void 0 : (_data$getAfterSalesLi = data.getAfterSalesLink) === null || _data$getAfterSalesLi === void 0 ? void 0 : _data$getAfterSalesLi.link);
        case 6:
          return _context10.abrupt("return", null);
        case 7:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _fetchUserOrderReturnLink.apply(this, arguments);
}
function fetchUserBLReturnEligibility(_x21, _x22) {
  return _fetchUserBLReturnEligibility.apply(this, arguments);
}
function _fetchUserBLReturnEligibility() {
  _fetchUserBLReturnEligibility = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(apolloClient, reference) {
    var _data$getAfterSalesEl, _yield$apolloClient$m2, data;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          if (!isValidToken()) {
            _context11.next = 6;
            break;
          }
          _context11.next = 3;
          return apolloClient.mutate({
            mutation: getAfterSalesEligibilityMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              input: {
                reference: reference
              }
            }
          });
        case 3:
          _yield$apolloClient$m2 = _context11.sent;
          data = _yield$apolloClient$m2.data;
          return _context11.abrupt("return", data === null || data === void 0 ? void 0 : (_data$getAfterSalesEl = data.getAfterSalesEligibility) === null || _data$getAfterSalesEl === void 0 ? void 0 : _data$getAfterSalesEl.isEligibleForReturn);
        case 6:
          return _context11.abrupt("return", null);
        case 7:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _fetchUserBLReturnEligibility.apply(this, arguments);
}
function signUpAsCustomer(_x23, _x24, _x25) {
  return _signUpAsCustomer.apply(this, arguments);
}
function _signUpAsCustomer() {
  _signUpAsCustomer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(context, form, recaptchaToken) {
    var response;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return context.mutate({
            errorPolicy: 'all',
            mutation: signUpCustomerMutation,
            variables: {
              input: form,
              recaptchaToken: recaptchaToken
            }
          });
        case 2:
          response = _context12.sent;
          return _context12.abrupt("return", response);
        case 4:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _signUpAsCustomer.apply(this, arguments);
}
function fetchUserAddresses(_x26) {
  return _fetchUserAddresses.apply(this, arguments);
}
function _fetchUserAddresses() {
  _fetchUserAddresses = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          if (!isValidToken()) {
            _context13.next = 5;
            break;
          }
          _context13.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'network-only',
            query: addressesQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            }
          });
        case 3:
          response = _context13.sent;
          return _context13.abrupt("return", response.data);
        case 5:
          return _context13.abrupt("return", null);
        case 6:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _fetchUserAddresses.apply(this, arguments);
}
function deleteUserAddress(_x27, _x28, _x29, _x30) {
  return _deleteUserAddress.apply(this, arguments);
}
function _deleteUserAddress() {
  _deleteUserAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(context, addressId, addressType, addressAlias) {
    var response;
    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          if (!isValidToken()) {
            _context14.next = 5;
            break;
          }
          _context14.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: deleteUserAddressQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              addressId: addressId,
              addressType: addressType,
              addressAlias: addressAlias
            }
          });
        case 3:
          response = _context14.sent;
          return _context14.abrupt("return", response.data);
        case 5:
          return _context14.abrupt("return", null);
        case 6:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _deleteUserAddress.apply(this, arguments);
}
function createUserAddress(_x31, _x32) {
  return _createUserAddress.apply(this, arguments);
}
function _createUserAddress() {
  _createUserAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(context, address) {
    var response;
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          if (!isValidToken()) {
            _context15.next = 5;
            break;
          }
          _context15.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: createUserAddressQuery,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              address: address
            }
          });
        case 3:
          response = _context15.sent;
          return _context15.abrupt("return", response.data);
        case 5:
          return _context15.abrupt("return", null);
        case 6:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _createUserAddress.apply(this, arguments);
}
function updateUserAddress(_x33, _x34, _x35) {
  return _updateUserAddress.apply(this, arguments);
}
function _updateUserAddress() {
  _updateUserAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(context, addressId, address) {
    var response;
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          if (!isValidToken()) {
            _context16.next = 5;
            break;
          }
          _context16.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: updateUserAddressMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              addressId: addressId,
              address: address
            }
          });
        case 3:
          response = _context16.sent;
          return _context16.abrupt("return", response.data);
        case 5:
          return _context16.abrupt("return", null);
        case 6:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _updateUserAddress.apply(this, arguments);
}
function updateUserInformation(_x36, _x37) {
  return _updateUserInformation.apply(this, arguments);
}
function _updateUserInformation() {
  _updateUserInformation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(context, user) {
    var response;
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          if (!isValidToken()) {
            _context17.next = 5;
            break;
          }
          _context17.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: updateUserInformationMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              user: user
            }
          });
        case 3:
          response = _context17.sent;
          return _context17.abrupt("return", response.data);
        case 5:
          return _context17.abrupt("return", null);
        case 6:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _updateUserInformation.apply(this, arguments);
}
function updateUserPassword(_x38, _x39, _x40) {
  return _updateUserPassword.apply(this, arguments);
}
function _updateUserPassword() {
  _updateUserPassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(context, oldPassword, newPassword) {
    var response;
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          if (!isValidToken()) {
            _context18.next = 5;
            break;
          }
          _context18.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: updateUserPasswordMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              oldPassword: oldPassword,
              newPassword: newPassword
            }
          });
        case 3:
          response = _context18.sent;
          return _context18.abrupt("return", response);
        case 5:
          return _context18.abrupt("return", null);
        case 6:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _updateUserPassword.apply(this, arguments);
}
function fetchDiscounts(_x41) {
  return _fetchDiscounts.apply(this, arguments);
}
function _fetchDiscounts() {
  _fetchDiscounts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(context) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          if (!isValidToken()) {
            _context19.next = 6;
            break;
          }
          locale = context.state.i18n.currentLocale.iso;
          _context19.next = 4;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'network-only',
            query: discountsQuery,
            variables: {
              locale: locale
            },
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            }
          });
        case 4:
          response = _context19.sent;
          return _context19.abrupt("return", response.data);
        case 6:
          return _context19.abrupt("return", null);
        case 7:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _fetchDiscounts.apply(this, arguments);
}
function updateUserOptin(_x42, _x43, _x44) {
  return _updateUserOptin.apply(this, arguments);
}
function _updateUserOptin() {
  _updateUserOptin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(context, input, addressId) {
    var response;
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          if (!isValidToken()) {
            _context20.next = 5;
            break;
          }
          _context20.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: updateUserOptinMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            },
            variables: {
              input: input,
              addressId: addressId
            }
          });
        case 3:
          response = _context20.sent;
          return _context20.abrupt("return", response.data);
        case 5:
          return _context20.abrupt("return", null);
        case 6:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _updateUserOptin.apply(this, arguments);
}
function subscribeToNewsletter(_x45, _x46, _x47) {
  return _subscribeToNewsletter.apply(this, arguments);
}
function _subscribeToNewsletter() {
  _subscribeToNewsletter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(context, email, optIn) {
    var locale, response;
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          locale = context.state.i18n.currentLocale.iso;
          _context21.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: subscribeToNewsletterMutation,
            variables: {
              email: email,
              optIn: optIn,
              locale: locale
            }
          });
        case 3:
          response = _context21.sent;
          return _context21.abrupt("return", response.data);
        case 5:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _subscribeToNewsletter.apply(this, arguments);
}
function updateUserToken(_x48) {
  return _updateUserToken.apply(this, arguments);
}
function _updateUserToken() {
  _updateUserToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          if (!isValidToken()) {
            _context22.next = 5;
            break;
          }
          _context22.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: updateUserTokenMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
              }
            }
          });
        case 3:
          response = _context22.sent;
          return _context22.abrupt("return", response.data);
        case 5:
          return _context22.abrupt("return", null);
        case 6:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _updateUserToken.apply(this, arguments);
}
function refreshToken(_x49) {
  return _refreshToken.apply(this, arguments);
}
function _refreshToken() {
  _refreshToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(context) {
    var response;
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: refreshTokenMutation,
            context: {}
          });
        case 2:
          response = _context23.sent;
          return _context23.abrupt("return", response.data);
        case 4:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _refreshToken.apply(this, arguments);
}
function fetchSpecialConditions(_x50, _x51) {
  return _fetchSpecialConditions.apply(this, arguments);
}
function _fetchSpecialConditions() {
  _fetchSpecialConditions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(defaultClient, maskedQuoteId) {
    var response;
    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return defaultClient.mutate({
            mutation: specialConditions,
            variables: {
              maskedQuoteId: maskedQuoteId
            }
          });
        case 2:
          response = _context24.sent;
          return _context24.abrupt("return", response.data);
        case 4:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _fetchSpecialConditions.apply(this, arguments);
}
function generateOrderFormReceipt(_x52, _x53) {
  return _generateOrderFormReceipt.apply(this, arguments);
}
function _generateOrderFormReceipt() {
  _generateOrderFormReceipt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(context, _ref) {
    var maskedQuoteId, shopId, uid, token, response;
    return regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          maskedQuoteId = _ref.maskedQuoteId, shopId = _ref.shopId, uid = _ref.uid, token = _ref.token;
          _context25.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: generateOrderFormReceiptMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(token)
              }
            },
            variables: {
              input: {
                cartId: maskedQuoteId,
                shopId: shopId,
                sellerId: uid
              }
            }
          });
        case 3:
          response = _context25.sent;
          return _context25.abrupt("return", response);
        case 5:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _generateOrderFormReceipt.apply(this, arguments);
}
function fetchFeatures(_x54) {
  return _fetchFeatures.apply(this, arguments);
}
function _fetchFeatures() {
  _fetchFeatures = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(_ref2) {
    var market, locale, logger, sellerContextStoreId, myHeaders, myInit, myRequest, data;
    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          market = _ref2.market, locale = _ref2.locale, logger = _ref2.logger, sellerContextStoreId = _ref2.sellerContextStoreId;
          _context26.prev = 1;
          myHeaders = new Headers();
          myHeaders.append('Content-Type', 'application/json');
          if (isValidToken()) {
            myHeaders.append('token', localStorage.getItem('MDM_ACCESS_TOKEN'));
          }
          myInit = {
            method: 'GET',
            headers: myHeaders
          };
          myRequest = new Request("".concat(window.location.origin, "/features?market=").concat(market, "&locale=").concat(locale, "&uuid=").concat(uuid.v1(), "&sellerContextStoreId=").concat(sellerContextStoreId), myInit);
          _context26.next = 9;
          return fetch(myRequest, myInit);
        case 9:
          data = _context26.sent;
          return _context26.abrupt("return", data.json());
        case 13:
          _context26.prev = 13;
          _context26.t0 = _context26["catch"](1);
          console.error(_context26.t0);
          logger === null || logger === void 0 ? void 0 : logger.error(_context26.t0);
        case 17:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[1, 13]]);
  }));
  return _fetchFeatures.apply(this, arguments);
}
function updateOrderForm(_x55, _x56) {
  return _updateOrderForm.apply(this, arguments);
}
function _updateOrderForm() {
  _updateOrderForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(context, _ref3) {
    var maskedQuoteId, tokenSeller, token, response;
    return regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          maskedQuoteId = _ref3.maskedQuoteId, tokenSeller = _ref3.tokenSeller, token = _ref3.token;
          _context27.next = 3;
          return context.app.apolloProvider.defaultClient.mutate({
            mutation: updateOrderFormMutation,
            context: {
              headers: {
                Authorization: "Bearer ".concat(token)
              }
            },
            variables: {
              maskedQuoteId: maskedQuoteId,
              tokenSeller: tokenSeller
            }
          });
        case 3:
          response = _context27.sent;
          return _context27.abrupt("return", response);
        case 5:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _updateOrderForm.apply(this, arguments);
}
function fetchAddressValidation(_x57, _x58) {
  return _fetchAddressValidation.apply(this, arguments);
}
function _fetchAddressValidation() {
  _fetchAddressValidation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(context, _ref4) {
    var streetName, country, postalCode, locality, _yield$context$app$ap6, data;
    return regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          streetName = _ref4.streetName, country = _ref4.country, postalCode = _ref4.postalCode, locality = _ref4.locality;
          _context28.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            query: addressValidationQuery,
            variables: {
              streetName: streetName,
              country: country,
              postalCode: postalCode,
              locality: locality
            }
          });
        case 3:
          _yield$context$app$ap6 = _context28.sent;
          data = _yield$context$app$ap6.data;
          return _context28.abrupt("return", data);
        case 6:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _fetchAddressValidation.apply(this, arguments);
}
export { fetchFeatures, autologin, createUserAddress, deleteUserAddress, fetchDiscounts, fetchSpecialConditions, fetchUser, fetchUserAddresses, fetchUserOrder, fetchUserOrderReturnLink, fetchUserBLReturnEligibility, fetchUserOrderForm, fetchUserOrderForms, fetchUserOrders, fetchUserProfile, generateOrderFormReceipt, updateOrderForm, loginUser, logoutUser, refreshToken, subscribeToNewsletter, updateUserAddress, updateUserInformation, updateUserOptin, updateUserPassword, updateUserToken, signUpAsCustomer, fetchAddressValidation };